import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlService } from '@services/datasources/url.service';
import { ClientDto } from 'app/@types/dto/client-dto.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ClientHttpService {
    constructor(
        private http: HttpClient,
        private urlService: UrlService,
    ) {}

    getClients(): Observable<ClientDto[]> {
        return this.http.get<ClientDto[]>(this.urlService.getClients());
    }
}
